// @flow

import styled, { css } from "styled-components";
import { fontBold, fontNormal } from "@fdr/static-ui/Typography";
import buildColor from "@fdr/static-ui/ColorPalette";
import Button from "../../_atoms/ButtonDefault";

export const RaceButton = styled.button`
  background-color: ${buildColor("white", "100")};
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  padding: 12px 16px;
  outline: none;

  & > * {
    flex-shrink: 0;
  }
`;

export const RaceSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  background-color: ${buildColor("white", "100")};

  & > * {
    flex-shrink: 0;
  }
`;

export const Date = styled.time`
  color: ${buildColor("navy", "900")};
  font-size: 12px;
  font-family: ${fontNormal};
  margin-left: 8px;
`;

export const RaceInfo = styled.div`
  flex: 1 1 auto;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;

  & > time {
    width: fit-content;
    margin-bottom: 8px;
  }
`;

export const TrackRace = styled.span`
  display: flex;
  text-align: left;
  align-items: center;
  font-family: ${fontBold};
  font-size: 14px;
  margin-bottom: 4px;
  color: ${buildColor("grey", "D4")};
  ${({ isCurrentRace }) =>
    isCurrentRace &&
    css`
      & > time {
        margin-left: 8px;
      }
    `}
`;

export const RaceDataList = styled.ul`
  ${({ hasMarginTop }) =>
    hasMarginTop &&
    css`
      margin-top: 8px;
    `};
  display: flex;
  flex-wrap: wrap;
  list-style: none;
`;

export const RaceDataListItem = styled.li`
  font-size: 14px;
  color: ${buildColor("grey", "D4")};
  line-height: 125%;

  &:not(:last-child) {
    border-right: 1px solid ${buildColor("grey", "L2")};
    padding-right: 8px;
    margin-right: 8px;
    height: 18px;
  }
`;

export const RaceArrowLink = styled(Button)`
  background: transparent;
  width: 32px;

  &:active {
    background-color: ${buildColor("white", "50")};
  }
`;

export const RaceArrowContent = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1px solid ${buildColor("grey", "300")};
  border-radius: 4px;
`;

export const RaceArrowNavigation = styled.div`
  display: flex;
  flex: 0 0 64px;
  flex-direction: row;
  align-items: stretch;
  margin-left: 8px;

  > :first-child {
    margin-right: 8px;
  }
`;

export const ResultItem = styled.li`
  color: ${buildColor("grey", "800")};
  font-size: 14px;
  font-family: ${fontNormal};
  display: flex;
  align-items: flex-end;

  &:not(:last-child) {
    border-right: 1px solid ${buildColor("grey", "L2")};
    padding-right: 8px;
    margin-right: 8px;
  }

  & > span {
    color: ${buildColor("grey", "900")};
    ${({ isCurrentRace }) =>
      !isCurrentRace
        ? css`
            margin-left: 4px;
          `
        : css`
            font-family: ${fontBold};
          `}
  }
`;

export const ReplayButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${buildColor("blue", "500")};
  background-color: ${buildColor("white", "100")};
  border: 1px solid ${buildColor("grey", "300")};
  border-radius: 4px;
  padding: 8px;
  font-size: 14px;
  align-self: center;
  ${({ isCurrentRace }) =>
    isCurrentRace &&
    css`
      & > svg {
        margin-right: 4px;
      }
    `}
`;

export const Position = styled.span`
  color: ${({ isPodium }) =>
    isPodium ? buildColor("green", "500") : buildColor("grey", "900")};
  font-family: ${fontBold};
  font-size: 14px;
`;

export const RaceNavigation = styled.div`
  width: 100%;
  display: flex;
  padding: 12px 16px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const TrackInfo = styled.span`
  color: ${buildColor("grey", "D4")};
  font-family: ${fontBold};
  font-size: 16px;
`;

export const DateWrapper = styled.div`
  margin-top: 8px;
  margin-bottom: 0;
  min-height: 20px;
`;
